import { render, staticRenderFns } from "./CreateBackendKeywords.vue?vue&type=template&id=87268ca8&scoped=true&"
import script from "./CreateBackendKeywords.vue?vue&type=script&lang=js&"
export * from "./CreateBackendKeywords.vue?vue&type=script&lang=js&"
import style0 from "./CreateBackendKeywords.vue?vue&type=style&index=0&id=87268ca8&lang=scss&scoped=true&"
import style1 from "./CreateBackendKeywords.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87268ca8",
  null
  
)

export default component.exports